import { render, staticRenderFns } from "./DetailFooter.vue?vue&type=template&id=7118a096&"
var script = {}
import style0 from "./DetailFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports